import { Link } from "react-router-dom";

export default function Love(){
    return(
        <div className="text-2xl text-white grid place-items-center bg-black bg-opacity-30 rounded-lg">Made with ❤ by <span className="text-red-500 underline"><a href="https://www.github.com/gitJamoo" target="_blank">James M. Smith</a></span></div>
    )
}